<template>

  <div class="contact service-portlet"  >
    <div class="container"  v-scroll-reveal="{ origin : 'top', duration : '1000', distance : '50px' }">
      <div class="header-text font-color-black" >
        <div class="liststyle margin"></div>
        <h3 class="font-color-black">독창적인 아이디어와<br>
          차별화된 기술력으로<br>
          경쟁력있는 서비스를 제작합니다.</h3>
        <p>레나소프트웨어는 사용자 이해와 미래 시장 예측을 바탕으로 독창적인 아이디어를 제공합니다.
          미디어의 변화와 비즈니스 이해를 바탕으로 서비스 전략을 도출하여 고객과 시장의 니즈를 총족시키는 경쟁력있는 서비스를 제작합니다.
          저희 레나소프트웨어와 함께 성공적인 서비스를 만들어 가고자 하신다면 아래 제공드리는 양식에 따라 문의해주시기 바랍니다.
        </p>
      </div>
    </div>

    <div class="container"  v-scroll-reveal="{ origin : 'top', duration : '1000', distance : '50px' }">
      <div class="three columns">
        <div class="header-text">
          <div class="liststyle margin"></div>
          <h5>프로젝트 정보</h5>
        </div>
      </div>
      <div class="thirteen columns input-form">
        <input type="text" name="contact-name" class="form-control" v-model="projectTitle"   placeholder="프로젝트 제목 (필수)"/>
        <p>프로젝트 형태(다중선택 가능)</p>
        <div class="select-project">
          <a v-on:click="projectType=0"><div v-bind:class="{active:projectType==0}">모바일 앱</div></a>
          <a v-on:click="projectType=1"><div v-bind:class="{active:projectType==1}">PC 어플리케이션</div></a>
          <a v-on:click="projectType=2"><div v-bind:class="{active:projectType==2}">웹사이트</div></a>
          <a v-on:click="projectType=3"><div v-bind:class="{active:projectType==3}">통신</div></a>
          <a v-on:click="projectType=4"><div v-bind:class="{active:projectType==4}">구축</div></a>
          <a v-on:click="projectType=5"><div v-bind:class="{active:projectType==5}">컨설팅</div></a>
          <a v-on:click="projectType=6"><div v-bind:class="{active:projectType==6}">브랭딩</div></a>
          <a v-on:click="projectType=7"><div v-bind:class="{active:projectType==7}">기타</div></a>
        </div>
        <p>프로젝트 성격</p>
        <div class="select-project">
          <a v-on:click="projectChar=0"><div v-bind:class="{active:projectChar==0}">새로 만들기</div></a>
          <a v-on:click="projectChar=1"><div v-bind:class="{active:projectChar==1}">리뉴얼</div></a>
          <a v-on:click="projectChar=2"><div v-bind:class="{active:projectChar==2}">운영, 유지보수</div></a>
          <a v-on:click="projectChar=3"><div v-bind:class="{active:projectChar==3}">기타</div></a>
        </div>

        <div class="input-row">
          <div class="price-select">
            <select name="price" v-model="price">
              <option value="0">예산</option>
              <option value="1">5백만원 이하</option>
              <option value="2">1천만원</option>
              <option value="3">2천만원</option>
              <option value="4">3천만원</option>
              <option value="5">5천만원</option>
              <option value="6">5천만원 이상</option>
            </select>
          </div>
          <input class="start-date" type="text" placeholder="시작일"/>
          <input class="end-date" type="text" placeholder="오픈예정일"/>
        </div>
        <textarea class="form-control" placeholder="의뢰하실 프로젝트 내용을 입력해주세요.(필수)" v-model="contents"></textarea>
        <!--<div class="input-row">
          <div class="attach-file">
            파일을 첨부하시려면 파일을 첨부해주세요.
          </div>
          <button class="button-attach">파일첨부</button>
        </div>-->
      </div>
    </div>

    <!--section2-->
    <div class="container"  v-scroll-reveal="{ origin : 'top', duration : '1000', distance : '50px' }">
      <div class="three columns">
        <div class="header-text">
          <div class="liststyle margin"></div>
          <h5>신청자 정보</h5>
        </div>
      </div>
      <div class="thirteen columns input-form">
        <div class="input-row input-row-2">
          <input class="user-name" type="text" placeholder="신청자명(필수)" v-model="userName"/>
          <input type="text"  placeholder="전화번호(필수)" v-model="userPhone"/>
        </div>
        <div class="input-row input-row-2">
          <input type="text" placeholder="회사명(필수)" v-model="userCompany"/>
          <input class="part-name" type="text"  placeholder="부서/직함" v-model="userPosition"/>
        </div>
        <div class="input-row input-row-2">
          <input type="text" placeholder="메일주소(필수)" v-model="userMail"/>
          <input class="homepage" type="text"  placeholder="홈페이지" v-model="userHome"/>
        </div>
        <textarea class="terms-box" placeholder="">주)레나소프트웨어 (이하 회사)는 당 사이트 이용자의 개인정보보호를 위해 최선의 조치를 취하고자 노력하고 있으며, "정보통신망 이용촉진 및 정보보호"에 관한 법률, 개인정보보호법 등 관련법령에서 정보통신서비스제공자가 준수해야 할 개인정보보호에 관한 규정들을 충실히 이행하고 있습니다. 회사는 당 개인정보취급방침을 통해 개인정보를 취급하는데 있어서 취해지는 조치들을 알려드리며, 개인정보취급방침을 개정하는 경우에는 웹사이트 공지사항을 통하여 공지합니다.

회사의 개인정보취급방침은 다음과 같은 내용을 담고 있습니다

1. 수집하는 개인정보의 항목 및 수집방법
- 필수항목 : 이름, 소속사, 휴대전화번호, 이메일
- 선택항목 : 직위, 첨부파일

2. 개인정보의 수집 및 이용목적
- 서비스 제공, 콘텐츠 제공, 맞춤 서비스 제공, 상담 및 컨설팅 운영 등
- 서비스 제공에 관한 계약 이행 및 불만 처리 등 민원 처리, 고지 사항 전달, 문의사항에 대한 응대 및 원활한 의사소통의 경로 확보

3. 개인정보의 보유.이용 기간
• 방문에 관한 기록
- 보존 근거 : 통신비밀보호법
- 보존 기간 : 3개월
            </textarea>
        <div class="terms-check-box">
          <input type="checkbox" id="terms" name="terms" v-model="agree"/>
          <label for="terms"><span></span>개인정보보호정책에 동의합니다.</label>
        </div>
        <button class="button-submit" v-on:click="send">프로젝트 의뢰하기</button>
      </div>

    </div>

  </div>
</template>
<script>
  export default {
    name: 'Contact',
    data () {
      return {
        projectTitle: '',
        projectType: 0,
        projectChar: 0,
        price: 0,
        startData: '',
        endDate: '',
        userName: '',
        userPhone: '',
        userCompany: '',
        userPosition: '',
        userMail: '',
        userHome: '',
        agree: false,
        contents: ''
      }
    },
    methods: {
      menuClick(title) {
        console.log('## click menu : ' + title)
        //this.menuVisible = false
        this.$emit('clicked',title)
      },
      send() {
        console.log('## projectTitle: ' + this.projectTitle)
        console.log('## projectType: ' + this.projectType)
        console.log('## projectChar: ' + this.projectChar)
        console.log('## price: ' + this.price)
        console.log('## startData: ' + this.startData)
        console.log('## endDate: ' + this.endDate)
        console.log('## userName: ' + this.userName)
        console.log('## userPhone: ' + this.userPhone)
        console.log('## userCompany: ' + this.userCompany)
        console.log('## userCompany: ' + this.userPosition)
        console.log('## userMail: ' + this.userMail)
        console.log('## userHome: ' + this.userHome)
        console.log('## agree: ' + this.agree)
        console.log('## contents: ' + this.contents)

        if(this.projectTitle == '' ) alert("프로젝트 제목을 입력해 주세요.")
        else if(this.contents =='' ) alert("프로젝트 내용을 입력해 주세요.")
        else
          alert("요청이 성공적으로 발생되었습니다.")

        this.projectTitle = ''
        this.projectType = 0
        this.projectChar = 0
        this.price = 0
        this.startData = ''
        this.endDate = ''
        this.userName = ''
        this.userPhone = ''
        this.userCompany =  ''
        this.userPosition = ''
        this.userMail = ''
        this.userHome = ''
        this.agree = false
        this.contents = ''
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Contact.vue